import React from "react";
import { usePartnerFormStore } from "../store/usePartnerFormStore";
import { Input, NavigationButtons } from "./ui";

const PartnerFormStep4: React.FC = () => {
  const {
    additionalInfo,
    updateAdditionalInfo,
    previousStep,
    nextStep,
    errors,
    setError,
    clearError,
  } = usePartnerFormStore();

  const validateStep = (): boolean => {
    let isValid = true;

    if (
      additionalInfo.incomeSharingPercentage < 1 ||
      additionalInfo.incomeSharingPercentage > 25
    ) {
      setError(
        "incomeSharingPercentage",
        "Income sharing percentage must be between 1% and 25%"
      );
      isValid = false;
    }

    if (
      additionalInfo.additionalWorkQuantity !== undefined &&
      additionalInfo.additionalWorkQuantity !== null
    ) {
      const quantity = Number(additionalInfo.additionalWorkQuantity);
      if (isNaN(quantity) || quantity < 0) {
        setError(
          "additionalWorkQuantity",
          "Quantity must be a positive number"
        );
        isValid = false;
      }
    }

    return isValid;
  };

  const handleNext = () => {
    if (validateStep()) {
      nextStep();
    }
  };

  const handleChange = (
    field: keyof typeof additionalInfo,
    value: string | number | undefined
  ) => {
    updateAdditionalInfo({ [field]: value as any });
    clearError(field);
  };

  return (
    <div className="space-y-5 md:space-y-6">
      <div>
        <h2 className="text-xl md:text-2xl font-semibold text-secondary-900 mb-2">
          Additional Work & Income Sharing
        </h2>
        <p className="text-sm md:text-base text-secondary-600">
          Provide details about additional work capacity and income sharing
        </p>
      </div>

      <div className="space-y-5 md:space-y-4">
        <Input
          label="Quantity of Additional Works"
          type="number"
          placeholder="Enter quantity (optional)"
          value={additionalInfo.additionalWorkQuantity || ""}
          onChange={(e) =>
            handleChange(
              "additionalWorkQuantity",
              e.target.value === "" ? undefined : Number(e.target.value)
            )
          }
          error={errors.additionalWorkQuantity as string}
          helperText="Optional: Number of additional works you can handle"
        />

        <div className="space-y-3">
          <Input
            label="Income Sharing Percentage"
            type="number"
            placeholder="Enter percentage (1-25%)"
            value={additionalInfo.incomeSharingPercentage}
            onChange={(e) =>
              handleChange("incomeSharingPercentage", Number(e.target.value))
            }
            error={errors.incomeSharingPercentage as string}
            required
            helperText="Minimum 1% to maximum 25% of total income through our platform"
            min={1}
            max={25}
          />

          {/* Visual range indicator */}
          <div className="px-1">
            <div className="flex justify-between text-xs text-secondary-500 mb-1">
              <span>1%</span>
              <span className="font-medium text-primary-600">
                {additionalInfo.incomeSharingPercentage}%
              </span>
              <span>25%</span>
            </div>
            <div className="h-2 bg-secondary-200 rounded-full overflow-hidden">
              <div
                className="h-full bg-primary-500 rounded-full transition-all duration-300"
                style={{
                  width: `${
                    ((additionalInfo.incomeSharingPercentage - 1) / 24) * 100
                  }%`,
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <NavigationButtons
        onPrevious={previousStep}
        onNext={handleNext}
        nextLabel="Next: Listing Details"
      />
    </div>
  );
};

export default PartnerFormStep4;
